import { useMemo } from 'react';

import { useAuthCache } from 'api/cache';
import { useCurrentTenant } from 'api/tenantCache';
import {
  ReadingCacheType,
  useReadAPIWithServices,
} from 'api/useAPIWithServices';
import { useAppServices } from 'container/depContext';

const useLogic = () => {
  const { loggedIn } = useAuthCache();

  const { getUserRepo } = useAppServices();
  const { getCurrentUserInfo } = getUserRepo();

  const { data: user } = useReadAPIWithServices(
    [loggedIn ? getCurrentUserInfo.name : null],
    getCurrentUserInfo,
    { cacheType: ReadingCacheType.Static }
  );

  const currentTenant = useCurrentTenant();

  const content = useMemo(
    () =>
      user ? `${user.organization.name}: ${currentTenant?.name}` : undefined,
    [currentTenant?.name, user]
  );

  return content;
};

export default useLogic;
